import {takeLatest, put, all} from 'redux-saga/effects';
import {closeModal} from '../actions';
import * as AC from '../actions/actionTypes';

function* closeModalSaga(action) {
  try {
    yield put(closeModal());
  } catch (e) {
    console.log(e);
  }
}

function* actionWatcher() {
  yield takeLatest(
    [
      AC.ADD_BUILDING_SUCCEED,
      AC.EDIT_BUILDING_SUCCEED,
      AC.DELETE_BUILDING_SUCCEED,
      AC.ADD_ADMIN_SUCCEED,
      AC.EDIT_ADMIN_SUCCEED,
      AC.DELETE_ADMIN_SUCCEED,
      AC.ADD_ENTRANCE_SUCCEED,
      AC.EDIT_ENTRANCE_SUCCEED,
      AC.DELETE_ENTRANCE_SUCCEED,
      AC.ADD_ELEVATOR_SUCCEED,
      AC.ADD_CARD_SUCCEED,
      AC.ADD_PAYMENT_SUCCEED,
      AC.DELETE_CARD_SUCCEED,
      AC.ADD_BUILDING_SUCCEED,
      AC.EDIT_BUILDING_SUCCEED,
      AC.DELETE_ELEVATOR_SUCCEED,
      AC.DELETE_CUSTOMER_SUCCEED,
      AC.ADD_GARAGE_SUCCEED,
      AC.EDIT_GARAGE_SUCCEED,
      AC.DELETE_GARAGE_SUCCEED,
      AC.ADD_CUSTOMER_GARAGE_SUCCEED,
      AC.EDIT_CUSTOMER_GARAGE_SUCCEED,
      AC.DELETE_CUSTOMER_GARAGE_SUCCEED,
    ],
    closeModalSaga,
  );
}

export default function* modalSaga() {
  yield all([actionWatcher()]);
}
